import { getLocalStorageExpire, setLocalStorageExpire } from 'utils/utils';

const STORAGE_KEY = 'origin';
const TTL_DAYS = 30;

function isValid(origin: unknown): origin is string {
  return (
    typeof origin === 'string' &&
    origin.length > 0 &&
    origin.length <= 64 &&
    /^[a-z0-9_-]+$/.test(origin)
  );
}

export function setOrigin(origin: string): void {
  const value = origin.trim().toLowerCase();
  if (!isValid(value)) return;

  setLocalStorageExpire(STORAGE_KEY, value, TTL_DAYS);
}

export function getOrigin(): string | null {
  const stored = getLocalStorageExpire(STORAGE_KEY);
  if (!stored) return null;

  return isValid(stored) ? stored : null;
}
